import type { RootState } from 'features/app/store/store';
import { PreviousCallReportSource } from 'features/call/vrs-call-comments/enums';

export const isPreviousCallIdExistSelector = ({ vrsCallComments }: RootState) =>
  Boolean(vrsCallComments.previousCallId);

export const previousCallIdSelector = ({ vrsCallComments }: RootState) =>
  vrsCallComments.previousCallId;

export const isReportNeededSelector = ({ vrsCallComments }: RootState) =>
  vrsCallComments.isReportNeeded;

export const reportTypeSelector = ({ vrsCallComments }: RootState) =>
  vrsCallComments.reportType;

export const selectPreviousCallReportSource = ({
  vrsCallComments,
}: RootState) => vrsCallComments.previousCallReportSource;

// Legacy selectors for backward compatibility
export const selectIsPreviousCallReportStartedFromLobby = ({
  vrsCallComments,
}: RootState) =>
  vrsCallComments.previousCallReportSource === PreviousCallReportSource.LOBBY;

// Derived selector for any previous call mode
export const selectIsAnyPreviousCallMode = ({ vrsCallComments }: RootState) =>
  vrsCallComments.previousCallReportSource !== PreviousCallReportSource.NONE;

export const selectPreviousCalls = ({ vrsCallComments }: RootState) =>
  vrsCallComments.previousCalls;

export const selectIsLoadingPreviousCalls = ({ vrsCallComments }: RootState) =>
  vrsCallComments.isLoadingPreviousCalls;

export const selectPreviousCallBeingReportedId = ({
  vrsCallComments,
}: RootState) => vrsCallComments.reportingPreviousCallId;

export const selectIsLikelyFirstCallOfShift = ({
  vrsCallComments,
}: RootState): boolean => {
  const { previousCalls } = vrsCallComments;
  if (!previousCalls || previousCalls.length === 0) return true;

  const EIGHT_HOURS_MS = 28_800_000; // 8 hours in milliseconds
  const now = Date.now();

  for (const call of previousCalls) {
    const timestamp = Date.parse(call.endTime || call.startTime || '');
    if (Number.isNaN(timestamp)) return false;
    // Calls within 8 hours are treated as the same shift — approximates a
    // typical shift and avoids counting short breaks or same-day split shifts as new shifts.
    if (now - timestamp < EIGHT_HOURS_MS) return false;
  }

  return true;
};

export const selectIsPreviousCallReportingEnabled = ({
  vrsCallComments,
}: RootState): boolean =>
  Boolean(vrsCallComments.isPreviousCallReportingEnabled);
